import { useState, useEffect } from "react";
import { fetchCurrentUser, getUserId, getEmpId, getBoId, getUserRole, hasRole, hasPermission } from "../utils/auth";

/**
 * Custom hook to fetch and provide current user info and permissions
 */
export const useCurrentUser = () => {
  const [loading, setLoading] = useState(true);
  const [userIdState, setUserIdState] = useState(null);
  const [empIdState, setEmpIdState] = useState(null);
  const [boIdState, setBoIdState] = useState(null);
  const [rolesState, setRolesState] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadUser = async () => {
      setLoading(true);
      const user = await fetchCurrentUser();
      if (isMounted && user) {
        setUserIdState(user.user_id);
        setEmpIdState(user.emp_id);
        setBoIdState(user.bo_id);
        setRolesState(user.roles || []);
      }
      if (isMounted) setLoading(false);
    };

    loadUser();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    loading,
    userId: userIdState ?? getUserId(),
    empId: empIdState ?? getEmpId(),
    boId: boIdState ?? getBoId(),
    roles: rolesState.length ? rolesState : getUserRole(),
    hasRole,
    hasPermission,
  };
};
